import { useGetBiomarkersV1BiomarkersGet } from '@/api/generated-catch-backend/biomarkers/biomarkers';
import '../../dashboard/dashboard-reset.css';

interface LabsOrderMarkersModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function LabsOrderMarkersModal({ isOpen, onClose }: LabsOrderMarkersModalProps) {
  const { data: biomarkersData, isLoading } = useGetBiomarkersV1BiomarkersGet({
    query: {
      enabled: isOpen,
    },
  });

  if (!isOpen) return null;

  const categories = biomarkersData?.categories || [];

  return (
    <>
      {/* Backdrop */}
      <div className="dashboard-reset modal-backdrop" onClick={onClose}>
        {/* Modal Container */}
        <div
          className="bg-white w-full max-w-full max-h-[85vh] overflow-y-auto relative rounded-[20px] md:max-w-[600px] mt-4"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Content */}
          <div className="p-6 md:p-8">
            {/* Header with Close Button */}
            <div className="flex items-start justify-between gap-4 mb-4">
              <div className="flex-1">
                <h1
                  className="text-2xl md:text-3xl font-semibold mb-2"
                  style={{
                    lineHeight: 'var(--line-height-tight)',
                    color: 'var(--color-text-primary)',
                    fontFamily: 'var(--font-family-inter)',
                  }}
                >
                  Your test includes 50+ biomarkers.
                </h1>
                <p
                  className="text-base"
                  style={{
                    color: 'var(--color-text-secondary)',
                    fontFamily: 'var(--font-family-inter)',
                  }}
                >
                  Included with your Catch membership.
                </p>
              </div>
              <button
                onClick={onClose}
                className="flex-shrink-0 w-10 h-10 flex items-center justify-center hover:bg-gray-100 transition-colors rounded-full"
                aria-label="Close modal"
              >
                <span className="text-2xl leading-none text-gray-600">&times;</span>
              </button>
            </div>

            {/* Price Banner */}
            <div
              className="rounded-full px-6 py-3 text-center mb-6"
              style={{
                backgroundColor: '#F0F5F6',
                color: '#5BC4BF',
                fontSize: '16px',
                fontFamily: 'var(--font-family-inter)',
              }}
            >
              $0 — Included with Free Trial & Membership
            </div>

            {isLoading ? (
              <div className="text-center py-8">
                <p style={{ color: 'var(--color-text-secondary)' }}>Loading biomarkers...</p>
              </div>
            ) : (
              <>
                {/* Dynamic Categories */}
                {categories.map((category) => (
                  <div key={category.metadata.slug} className="mb-6">
                    <h2
                      className="text-lg font-semibold mb-3"
                      style={{
                        color: 'var(--color-text-primary)',
                        fontFamily: 'var(--font-family-inter)',
                      }}
                    >
                      {category.metadata.displayName}
                    </h2>
                    <ul
                      className={`gap-x-4 gap-y-2 ${
                        category.biomarkers.length > 2 ? 'grid grid-cols-2' : 'space-y-2'
                      }`}
                      style={{ paddingLeft: '1.25rem' }}
                    >
                      {category.biomarkers.map((biomarker) => (
                        <li
                          key={biomarker.metadata.slug}
                          style={{
                            fontSize: '16px',
                            lineHeight: '1.5',
                            color: 'var(--color-text-secondary)',
                            fontFamily: 'var(--font-family-inter)',
                            listStyleType: 'disc',
                            display: 'list-item',
                          }}
                        >
                          {biomarker.metadata.displayName}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
